 
  export const mapConfiguration = {
            azure: '4KXaBiJe5JQENxwEhnuEwMeTAul05tG2aHjLyiP028NJmMxXCOBhJQQJ99BCAC5RqLJZtxW3AAAgAZMP1bHB'
          };